import { useContext } from 'react';

import { LoadingBackdrop } from '@olxbr/design-system';

import ListContainer from 'components/molecules/list-container';

import Modal from 'components/molecules/modal';
import lurkerMetrics from 'util/lurker-metrics';
import { useContactUsLit } from 'hooks/contact-us-list/use-contact-us-list';

import { UserContext } from '../../context/user-context';
import { CatalagProps, ServiceProps } from './types';

type Props = {
  loggedInUserEmail?: string;
  onClick: Function;
  // eslint-disable-next-line react/require-default-props
  stepToShow?: number;
  // eslint-disable-next-line react/require-default-props
  onChangeCatalog?: Function;
  catalogs: CatalagProps[];
  services: ServiceProps[];
};

const List = (props: Props) => {
  const loggedUser = useContext(UserContext);

  const {
    loading,
    catalogsToShow,
    handleClick,
    isLoginModalVisible,
    setLoginModalVisible,
    onLoginConfirmClick,
  } = useContactUsLit({ loggedUser, ...props });
  return (
    <>
      {loading ? (
        <LoadingBackdrop />
      ) : (
        <ListContainer
          itens={catalogsToShow}
          clickHandler={(item: any) => handleClick(item)}
        />
      )}
      <Modal
        visible={isLoginModalVisible}
        backButton={() => {
          lurkerMetrics('click', 'login_cancel', {
            object_name: 'order_list',
          });
          setLoginModalVisible(false);
        }}
        nextButton={onLoginConfirmClick}
        backButtonLabel="Cancelar"
        title="Quer falar sobre compras?"
      >
        Para entrar em contato sobre suas compras você precisa logar na OLX.
      </Modal>
    </>
  );
};

export default List;
